import script from "./ChangeBookingInterval.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeBookingInterval.vue?vue&type=script&setup=true&lang=js"

import "./ChangeBookingInterval.vue?vue&type=style&index=0&id=cff8f454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cff8f454"]])

export default __exports__